<h2 mat-dialog-title>Edit {{ data.day | dayofweek }} availability</h2>
<mat-dialog-content class="availability-card">
  @if (starts.length <= 0) {
    <div>
      <mat-form-field appearance="outline" class="unavailable">
        <mat-label>
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.UNAVAILABLE' | translate }}
        </mat-label>
        <input matInput disabled />
      </mat-form-field>
    </div>
  }
  @for (start of starts.controls; track start; let i = $index) {
    <div class="interval">
      <forms-time-picker
        class="time-picker"
        [control]="start"
        (hasAnyErrors)="timePickerHasErrors('start', i, $event)"
        appearance="outline"
        label="{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_START' | translate }}"
        placeholder="9:00 AM"
      ></forms-time-picker>
      <span class="spacing"></span>
      <forms-time-picker
        class="time-picker"
        [control]="ends.controls[i]"
        (hasAnyErrors)="timePickerHasErrors('end', i, $event)"
        appearance="outline"
        label="{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_END' | translate }}"
        placeholder="5:00 PM"
      ></forms-time-picker>
      <button mat-icon-button (click)="removeRange(i)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
  <button mat-button color="primary" (click)="addRange()" [disabled]="isInvalid()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_ADD_INTERVAL' | translate }}
  </button>
  @if (isInvalid()) {
    <mat-error>{{ getValidationError() }}</mat-error>
  }

  <!-- Copy to weekdays checkbox - hide for multihost -->
  @if (!data.isMultiHost) {
    <div class="copy-weekdays-section">
      <mat-checkbox
        [(ngModel)]="copyToWeekdays"
        [matTooltip]="'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COPY_TO_WEEKDAYS_TOOLTIP' | translate"
        >
        {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COPY_TO_WEEKDAYS' | translate }}
      </mat-checkbox>
    </div>
  }
  @if (this.data.isMultiHost) {
    <div>
      <h3>{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COMMON_AVAILABILITY.HEADER' | translate }}</h3>
      @if (this.data.availableSlots.length > 0) {
        <div>
          <ul>
            @for (val of this.data.availableSlots; track val) {
              <li>
                {{ val }}
              </li>
            }
          </ul>
        </div>
      }
      @if (this.data.availableSlots.length === 0) {
        <div
          [innerHTML]="'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.NO_CALENDAR_AVAILABILITY' | translate"
        ></div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="isInvalid()" (click)="callbackAndClose()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_SAVE' | translate }}
  </button>
</mat-dialog-actions>
